import { Alert, Stack } from '@mui/material';
import React from 'react';
import { FinsightEntity } from 'shared';

import { CreateEntityForm } from './CreateEntityForm';
import { CreateEntityModalMore } from './CreateEntityModalMore';
import { CreateEntityTable } from './CreateEntityTable';
import { CsvEditorDialog } from './CsvEditorDialog';
import { useCreateEntityController } from './index.controller';

type CreateEntityProps = {
  type: string;
  parent?: FinsightEntity;
  moreClicked?: boolean;
};

export function CreateEntityModalView(props: CreateEntityProps) {
  const controller = useCreateEntityController(props);

  return (
    <Stack gap={2}>
      {controller.error && (
        <Stack direction="row" width="100%">
          <Alert
            severity="error"
            onClose={() => controller.setError(null)}
            sx={{ flexDirection: 'row !important', width: '100%' }}
          >
            {controller.error}
          </Alert>
        </Stack>
      )}

      {controller.isTableMode ? (
        <CreateEntityTable
          csvEntities={controller.csvEntities}
          loading={controller.loading}
          modalCtx={controller.modalCtx}
          onEditCsvEntities={controller.handleEditCsvEntities}
          onCancelTableMode={controller.handleCancelTableMode}
          onCreateMultipleEntities={controller.handleCreateMultipleEntities}
        />
      ) : (
        <CreateEntityForm
          entity={controller.entity}
          parent={props.parent}
          entityTypes={controller.entityTypes}
          requiredFields={controller.requiredFields}
          optionalFields={controller.optionalFields}
          loading={controller.loading}
          canSubmit={Boolean(controller.canSubmit)}
          modalCtx={controller.modalCtx}
          onEntityChange={controller.setEntity}
          onOpenTextInput={controller.handleOpenTextInput}
          onCreateEntity={controller.handleCreateEntity}
        />
      )}

      <CsvEditorDialog
        open={controller.textInputDialogOpen}
        value={controller.textInput}
        onClose={controller.handleCloseCsvDialog}
        onChange={(value) => controller.setTextInput(value)}
        onSubmit={controller.handleTextInputSubmit}
      />
    </Stack>
  );
}

export function CreateEntityModalMain(props: CreateEntityProps) {
  if (props.moreClicked) {
    return <CreateEntityModalMore {...props} />;
  }

  return <CreateEntityModalView {...props} />;
}
